module.exports = __webpack_public_path__ + "img/media_9.c1f35e45.jpg";